export default __webpack_public_path__ + "f96bce28981253ffa6b6db0385e6dab9.png";